var _defs, _text, _text2, _polygon, _polygon2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _text3, _text4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideMaterial8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 567.24 338.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:8px;fill:#231f20;font-family:ProximaNova-Light, Proxima Nova;font-weight:300;}.cls-2{font-size:23.62px;font-family:ProximaNova-Black, Proxima Nova;font-weight:800;}.cls-2,.cls-5,.cls-7{fill:#7c2a8c;}.cls-3{letter-spacing:-0.06em;}.cls-4{fill:#f0512a;}.cls-6{fill:#fff;}.cls-7{font-size:11.25px;font-family:ProximaNova-Regular, Proxima Nova;}.cls-8,.cls-9{fill:none;stroke-miterlimit:10;stroke-width:0.25px;}.cls-8{stroke:#ffcc04;}.cls-9{stroke:#6b7b84;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 336.16)"
  }, "Size: 16:9")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(191.53 167.5)"
  }, "PRESEN", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 92.02,
    y: 0
  }, "TA"), /*#__PURE__*/React.createElement("tspan", {
    x: 120.01,
    y: 0
  }, "TION TITLE"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "143.69 319.06 95.86 239.33 48.02 319.06 143.69 319.06"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "0.19 0.16 48.02 0.16 143.69 159.61 48.02 319.06 0.19 319.06 0.19 0.16"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M49,175.23l-.9.13a2.93,2.93,0,0,1-.45.1c-.35,0-.53-.44-1-.54-.12,0,0,0-.18-.06s.06,0-.23-.11c0,.32-.06.23-.06.48a1.94,1.94,0,0,0,.19.82c.09.18.13.12.12.38a1.63,1.63,0,0,0,.14,1,2.61,2.61,0,0,1,.36.73c.48,0,.41,0,.47.14.45,0,.16-.1.41-.14,0,0,.45.11.34-.46.33.09.17.26.39.24s.09-.16.12-.37-.09-.06.23-.21L48.9,177c0-.47.11,0,.27.07l.2-1.43c0-.1.15-.06-.13-.46C48.93,175.2,49.11,175.21,49,175.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M49.17,174c-.05.19.11.11-.13.13l.27.6c.12-.06.08-.05.27-.06,0-.41,0-.27-.14-.47S49.35,174.06,49.17,174Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.79,173.47c-.07.28,0,0-.09.22s-.12.61.29.39C46,173.6,46,173.64,45.79,173.47Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M40.57,168.68a2.47,2.47,0,0,0-.82.13c-.5.13-.28.24-.12.48a3,3,0,0,0,1.17-.17c.22,0,.24,0,.11-.24h-.34Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M54.27,165.36a1,1,0,0,0-.06-.23l-.77-.28c-.55-.21-1.1-.41-1.64-.63s-1.1-.45-1.72-.76-1.31-.66-2-1.08a4.55,4.55,0,0,1-1.65-1.86,7.36,7.36,0,0,1-.37-.94h-.13a3.36,3.36,0,0,0-.74.1l-.7.18a9.18,9.18,0,0,1-1.89.36h-.25c-.23,0-.47,0-.71,0a4.5,4.5,0,0,1-.54,0A9.47,9.47,0,0,1,40,160l-.4-.09-.31.36a1.29,1.29,0,0,1,.21.19,1.35,1.35,0,0,1,.28,1.33,2,2,0,0,1-1.76,1.3c-.23,0-.44,0-.65,0h-.1a2.18,2.18,0,0,1-1.75-1.14,1.54,1.54,0,0,1,.13-1.7l0-.05.29-.42a4.91,4.91,0,0,0,.31-.5l.18-.35a2.32,2.32,0,0,1-1.95-1.47,4.64,4.64,0,0,1-.3-1.42l-.2.05-.31.08a2.8,2.8,0,0,1-.27.3,1.71,1.71,0,0,1-1.2.56,1.66,1.66,0,0,1-.48-.08h-.07a1.55,1.55,0,0,1-.9-.28,1.09,1.09,0,0,1-.51-.36,1.18,1.18,0,0,1-.23-1,4.33,4.33,0,0,1,.78-1.68l.09-.13a1.62,1.62,0,0,1,.47-1c.21-.2.41-.38.62-.55l.16-.14a3.67,3.67,0,0,1,.34-.27,2.26,2.26,0,0,1,.32-.9,3.86,3.86,0,0,1,1.12-1.08c.23-.15.47-.28.69-.4L35,149l.32-.2.17-.11a1,1,0,0,1,.54-.15,1.12,1.12,0,0,1,.44.09,1.07,1.07,0,0,1,.58,1.23s-.26.89-.34,1.18a2.72,2.72,0,0,1-.5.93c.22.14.48.31.73.5a4.39,4.39,0,0,1,.58.55h.44l.15,0a3.74,3.74,0,0,0,1.07-.49l.16-.09a8.86,8.86,0,0,1,2.1-1,14,14,0,0,1,3.74-.53h.5c.69,0,1.38,0,2,.08a10.28,10.28,0,0,1,1.55.21A9,9,0,0,1,53,152.79a.68.68,0,0,0-.37-.52c-.2-.09-.1,0-.24-.12s0,0,0,0l-.15-.12c-.24-.15-.2,0-.29-.33l-.09.05,0,0c-.15,0-.1-.26-.24-.43s.06.13-.29-.05c-.19-.09,0,0-.11-.08a.3.3,0,0,0-.14-.07l-.12,0c-.56-.23-.46-.32-.46-.88-.47-.13-.18-.5-.15-.81,0-.49-.24-.55-.12-1.09-.67,0-.4-.66-.59-1.38l0-.65c0-.14,0,.06.08-.19L49.4,146c-.64-.38-.51-.67-.7-.79l-.46.15c-.14.1,0,.07-.21.12-.45-.42-.24-1.29-.39-1.85-.06-.24-.11-.56-.43-.64a1,1,0,0,1,.2-.41c-.16-.08-.24-.06-.4-.14a1.93,1.93,0,0,0-.21-1.08c-.13-.22,0-.24-.34-.27-.08.32-.05.13-.33.27a1.89,1.89,0,0,1-.25,1s0,0,0,0l-.06.08a1.34,1.34,0,0,0-.28.66h.2c0,.31,0,.13-.15.32s-.08,0,0,.34-.24.38-.21.75.11.17.1.41-.07.2-.06.39c0,.5.21.37,0,.86s-.15,1-.46,1.5a5.84,5.84,0,0,0-.35.73,1,1,0,0,1-.76.3,3.15,3.15,0,0,1-.69-.34c-.13-.07-.23-.11-.29-.24s0-.09-.08-.2c-.16-.33-.6-.3-.92-.42s-.44-.58-1.22-.88l-.4-.13-.32-.22-.26-.29c-.08-.07-.22-.15-.32-.23l-.29-.18c-.27-.14-.23,0-.24-.37.15-.05.32-.33.45-.51s0,0,.08-.12l.06-.15,0,0,.14-.33c-.28-.11,0,0-.27-.07.11-.16.08-.07.14-.27.35-.17.26-.07.47,0,.41-.6.17-.22.26-.57s.27-.35.41-.57l-.25-.16c-.27-.15-.21.11-.21-.39a1.27,1.27,0,0,0-.55.41c-.07-.09-.07.14-.07-.2a1,1,0,0,1-.34.13c.2-.26.11,0,.21-.27a1.75,1.75,0,0,0-.89.34c-.16-.12-.26-.11-.33-.34-.34,0-.09.05-.4.14a1.59,1.59,0,0,0-.55-.28v-.12c-.36,0-.6.22-.9-.12,0,0-.15-.25-.18-.29-.25.07-.14.07-.34.2a.53.53,0,0,0-.3-.38c-.11-.07,0,0-.14-.05l-.38,0c-.05,0,.1,0-.2.06v.21c.26.06,0,0,.19.08l.05,0s0,0,0,0c.2.09.22,0,.54,0a1.48,1.48,0,0,1,.13.61l-.5.17,0,0-.61.07c-.26,0-.17-.06-.26-.26l-.18.09-.17.1c-.2.15.1.06-.23.18a.63.63,0,0,1-.31,0c0,.18,0,.17-.15.39s0,.19-.33.22c0,.49,0,.21.14.54l-.22.08c-.34.08-.18.08-.3.42s-.28.09-.42.72c.21.15.26.15.3.29a.51.51,0,0,1,0,.24c-.64,0-.35,0-.59,0a2.9,2.9,0,0,0-.76-.11c0,.49,0,.15-.14.28l0,0-.1.16c0-.46.1-.14.13-.53-.57-.16-.55-.77-1.12-.87s0-.14-.5-.15c-.12.25-.05.3-.27.47.07-.32,0-.1,0-.2-.25.06-.15.07-.34.2,0-.31-.08-.26-.34-.13.05.2,0,.14.2.2a.8.8,0,0,0-.14.41L28,145c-.18.35,0,.23-.26.42l-.09.05-.2.13c.1.37.18.07.07.34-.23,0-.25.1-.41.31l0,0-.05.06-.11.1c-.1.09-.22.13-.25.33a.6.6,0,0,0,.17.39c-.15.18-.13.12-.14.41l-.3-.1c-.3-.07-.15.17-.23-.1h-.34c0,.46-.17.35-.07.55s.25.16.41.39c-.17.07-.06,0-.27,0,0,.36.08.12,0,.48-.21-.15-.1-.11-.34-.55s-.25-.15-.21-.6c-.28.08-.26.22-.4.4l-.33.35a1.2,1.2,0,0,0-.27.54c0,.2.12.3.12.66.05,0,0,0,0,0l.17,0c0,.15,0,.08-.1.18l-.06.07c-.1.11,0,0-.11.1l-.11.09,0,0-.07.06c-.17.14-.13.16-.21.33l0,.09c-.41,1.07-.66,1.07-1.86,1.53-.23.08,0,.05-.25.07s-.18-.16-.46,0-.05.16-.27.34-.39-.11-1,.53a.55.55,0,0,1-.42.17c-.35,0-.09-.2-.54.1,0-.36.07-.13-.13-.21-.06.22-.05.18-.23.32-.41.31-.08-.09-.66.55L18,154l-.21.26-.06.08c-.32.36-1,.21-1,1.29h-.2a4.77,4.77,0,0,1-.07-.74,1.58,1.58,0,0,0-.47,1.21c.21.08.06-.11.17.17a1,1,0,0,1,0,.83,1.09,1.09,0,0,0-.13.37V158c0,.16.06.11.21.3s.05.25.35.59l0,0c.08.1.09.13.17.24.27.35.38.17.38,1H17a1.1,1.1,0,0,0-.75-.88c0,.63.17.21.21.68-.16-.1-.07-.08-.27-.13,0,.34.06.12-.13.19.43.66,1.12.91,1.29,1.75.07.38.47.58.61.89s0,0,.11.22l.2.2a1,1,0,0,1,.23.58c.23,1.43,1.1,1.73,1.19,2.58v.51c-.05.3,0,.25.11.54s0,.4-.1.63a1.53,1.53,0,0,1-.4-.06c0,.49,0,.93.42.92s.76.7,1.7.54a3.51,3.51,0,0,0,1-.13c.27-.16.3-.32.4-.43l0,0,.1-.11.06-.07.2-.12c.16,0,.41,0,.48-.23,0,0,0-.11,0-.13.1-.38.63-.37,1-.49l.78-.11h.16c.25,0-.07,0,.18,0l.1,0,0,0c.23.11-.18.06.24.09.06-.15.14-.23.57-.22s.79.21,1-.7a.65.65,0,0,1,.13-.35c.17-.2.28-.11.54-.27,1.08-.62.66-.73,1.88-.75a3.59,3.59,0,0,0,1.3-.4c.79-.31.71-.54,2-.54a2.94,2.94,0,0,0,.77-.11c.3-.05.9.43,1.13.57.39-.09.18-.27.66,0,.28.17.48.11.82.19.09.21,0,0,0,.34.22-.05.22-.09.41,0-.06.15-.13.1-.17.25l.14.39c.17.14.3,0,.47.2s.11.29.36.6a1.14,1.14,0,0,1,.21.65s0,0,0,0H38.3l-.16.18c.4,0,.29.3.66.39.13,0,0,0,.14,0s0,0,.14.06l0-.27c-.05-.21,0-.27.4-.73s.72-.32.9-.67a1.55,1.55,0,0,1,.3-.5c.17-.18,0,.06.15-.19l0,0s0,0,.06.08L41,166c-.2,0-.17,0-.27.13.14.31.15.27,0,.46a1.58,1.58,0,0,0-.34,1.06c0,.4-.09.31-.46.31-.06.25-.11.19-.14.47a1.56,1.56,0,0,0,.48-.13c.28-.07.31.15.47-.2l.27-.82.13.21s0,0,0,.05l0,.09a.08.08,0,0,1,0,0c.38.76-.25.78-.29,1.23a2.22,2.22,0,0,0,.68-.13s0,0,0,0,0,0,0,0c.42.36.86.82.67,1.44v0l0,.34a1.17,1.17,0,0,0,.29.42l.28.46c.21.23.52.13.76.4l.19.21c.2-.07.2-.15.41-.09l.14.06.06,0c.18,0,.09,0,.26.08s.69.39.75.54c.38,0,1.1-1,1.28-.27.34,0,.35-.24.62-.27l-.05.09c-.09.2,0-.12-.09.25l.32.29.1.1.21.08a.52.52,0,0,1,.12.27.32.32,0,0,0,.2-.47c.79,0,1-.8,1.87-.77.54,0,1,.19,1.37-.12l.14-.19c.1-.24,0-.3,0-.51l.36-1a1.32,1.32,0,0,1,.71-.87c.2-.17.05-.05.07-.18v-.05l0-.18a1.31,1.31,0,0,1,.37-.64c.4-.33.23-.56.83-1.2l.38-.22,0,0,.14-.1C54.45,166.3,54.37,165.83,54.27,165.36Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M24.49,149.63Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M37,154a7.2,7.2,0,0,0-.69-.67,10.32,10.32,0,0,0-1-.68,2.41,2.41,0,0,0-.53-.2.91.91,0,0,0-.33,0,2.32,2.32,0,0,1,.57-.64,2,2,0,0,0,.74-1c.12-.39.23-.78.34-1.18h0l-.52.32c-.32.19-.67.36-1,.56a2.81,2.81,0,0,0-.82.79,1.13,1.13,0,0,0-.16.82c0,.2-.1.21-.1.21a1.35,1.35,0,0,0-.59.35c-.25.21-.5.41-.73.64a.65.65,0,0,0-.18.36,1,1,0,0,1-.28.61,3.42,3.42,0,0,0-.6,1.28c0,.16,0,.23.22.2a.47.47,0,0,0,.54.2s.06,0,.08,0c.35.17.52.14.84-.18a1.37,1.37,0,0,0,.23-.25c.16-.25.43-.27.68-.34a1.94,1.94,0,0,0,.83-.33s.18-.16.27,0a2.24,2.24,0,0,1,.33.43,2.08,2.08,0,0,1,.16.64,4.06,4.06,0,0,0,.23,1.24,1.33,1.33,0,0,0,1.55.81,2.65,2.65,0,0,1,1.34,0l.26.12-.5-.05c-.09,0-.13,0-.17.11-.24.56-.46,1.12-.74,1.65-.18.35-.43.66-.64,1s-.31.43-.16.67a1.17,1.17,0,0,0,.94.66q.34,0,.69,0a1.05,1.05,0,0,0,.79-.58.37.37,0,0,0-.1-.38.34.34,0,0,1-.35.21.84.84,0,0,0-.22.1c0-.15.14-.15.27-.19l0-.29-.08,0c-.14.2-.22.23-.45.16l-.19-.06c-.2-.06-.23,0-.25.15s0,.09,0,.15a.42.42,0,0,1,0-.53c.25-.31.51-.62.79-.91a10.59,10.59,0,0,0,1.59-2.12,1.4,1.4,0,0,0,.14-.39.78.78,0,0,0-.36-.8,6.73,6.73,0,0,0-1-.57.66.66,0,0,1-.41-.79l.08.25c.07.24.3.32.49.42s.63.3.93.47a.94.94,0,0,1,.3,1.5c-.17.26-.33.52-.49.79-.06.09-.06.15.09.18.54.1,1.08.25,1.62.31a8.58,8.58,0,0,0,1.34,0,14.47,14.47,0,0,0,2.42-.51,3.62,3.62,0,0,1,1.43-.08l.1,0-.09-.76-.06-.63a5.12,5.12,0,0,0-.5-2.07c-.06-.1-.14-.2-.22-.32a1.34,1.34,0,0,1,.47.41,2.43,2.43,0,0,1,.38,1c.12.62.2,1.25.3,1.87a7,7,0,0,0,.56,1.95,3.55,3.55,0,0,0,1.28,1.46c.61.38,1.26.71,1.91,1s1.09.51,1.65.73,1.39.53,2.09.79l1,.37a.6.6,0,0,1,.41.38l-.55-.28,0,0c.06.2.13.39.17.59.1.52.19,1.05.28,1.57s.14.82.2,1.24c0,.22,0,.45,0,.68a1.42,1.42,0,0,0,.32,1c.06.07.14.13.21.2a7.14,7.14,0,0,1,1.18,1.45,1.12,1.12,0,0,0,.41.37h.33s0-.07,0-.09a.4.4,0,0,1,0-.52,1.31,1.31,0,0,0,.15-.37c0-.22-.1-.37-.21-.54A1.07,1.07,0,0,0,58,170l-.27.35h0a.62.62,0,0,0,.09-.72,1.13,1.13,0,0,0-.45-.62,1.1,1.1,0,0,1-.53-.91c-.07-.47-.11-.95-.16-1.42a5.93,5.93,0,0,1-.07-.83c0-.4.09-.8.12-1.2a.91.91,0,0,0-.24-.65,5.23,5.23,0,0,0-1.11-.82c-.69-.49-1.4-1-2.06-1.49A9.34,9.34,0,0,1,51,159a3.13,3.13,0,0,1-.39-1.16,2,2,0,0,1,.13-1A4.18,4.18,0,0,0,51,158.6c.36-.09.69-.23.75-.63a2.52,2.52,0,0,0,0-.72c0-.22.08-.35.3-.31a1.16,1.16,0,0,1,.7.54c.56.82,1.09,1.67,1.63,2.51.33.51.65,1,1,1.52.46.67.92,1.34,1.41,2a11.38,11.38,0,0,0,.85,1c.27.29.55.56.84.84a10,10,0,0,0,1.81,1.37,10.38,10.38,0,0,0,2.6,1.14,17.91,17.91,0,0,0,1.93.42,8.76,8.76,0,0,0,1.62.09,12.27,12.27,0,0,0,1.71-.2,9.7,9.7,0,0,0,2.56-.88c.39-.2.76-.45,1.14-.68,0,0,.06-.05.06-.07a2.51,2.51,0,0,0,0-.27c-.07,0-.16,0-.22,0l-.6.26a12,12,0,0,1-2.17.78,11.17,11.17,0,0,1-1.51.29,11.78,11.78,0,0,1-1.68,0,7,7,0,0,1-2.87-.82,8.37,8.37,0,0,1-1.93-1.35c-.22-.2-.44-.4-.65-.61a15.12,15.12,0,0,1-1.53-1.86,29.2,29.2,0,0,1-1.62-2.67l-1.08-2a19.06,19.06,0,0,0-1.76-2.77A12.13,12.13,0,0,0,52.86,154,8,8,0,0,0,49,152.16,11.26,11.26,0,0,0,47.6,152c-.81-.05-1.63-.08-2.44-.06a13.71,13.71,0,0,0-3.48.48,8.91,8.91,0,0,0-2,1,4.54,4.54,0,0,1-1.37.6,1.57,1.57,0,0,1-.37,0,7.4,7.4,0,0,0-.82,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M125.75,143.26h-.55v1.55h-.32v-1.55h-.55v-.32h1.42Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M127.74,142.94v1.87h-.32v-1.32l-.61.95-.61-.95v1.32h-.32v-1.87h.35l.58.91.59-.91Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.67,147.78v.59a4.62,4.62,0,0,0-1.06-.56,3.9,3.9,0,0,0-1.37-.23,4.05,4.05,0,0,0-1.61.31,3.91,3.91,0,0,0-1.27.84,4,4,0,0,0-1.13,2.81,3.94,3.94,0,0,0,.3,1.53,4,4,0,0,0,.83,1.26,3.91,3.91,0,0,0,1.27.84,4.05,4.05,0,0,0,1.61.31h.16a4.31,4.31,0,0,0,1.61-.3V153h0a2.07,2.07,0,0,1-.74.47,2.27,2.27,0,0,1-.86.16,2.22,2.22,0,0,1-.37,0h0a1.74,1.74,0,0,1-.51-.13,2,2,0,0,1-.73-.47,2,2,0,0,1-.67-1.51,2,2,0,0,1,.67-1.53,2.23,2.23,0,0,1,.73-.47,2.37,2.37,0,0,1,.88-.16A2.23,2.23,0,0,1,76,150a2,2,0,0,1,.67,1.53v3.94h1.89v-7.7Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68.65,155.48l-4.2-4v4H62.56V144.81h1.89v4l4.2-4h2.68l-5.54,5.32,5.54,5.34Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M83.49,147.58a3.37,3.37,0,0,1,1.4.28,3.2,3.2,0,0,1,1.08.76,3.64,3.64,0,0,1,.7,1.13,3.93,3.93,0,0,1,.24,1.38v4.35H85v-4.35a1.62,1.62,0,0,0-.55-1.24,1.82,1.82,0,0,0-1.3-.51,1.84,1.84,0,0,0-1.31.51,1.64,1.64,0,0,0-.54,1.24v4.35H79.43v-7.69h1.89v.57a3.72,3.72,0,0,1,1-.56A3,3,0,0,1,83.49,147.58Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.16,147.79a3.38,3.38,0,0,1,1.27-.22v1.79a2.25,2.25,0,0,0-1.61.63,2.1,2.1,0,0,0-.66,1.53v4h-1.9v-7.7h1.9v.58A4.07,4.07,0,0,1,109.16,147.79Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.71,147.58a4.22,4.22,0,0,1,1.63.31,4,4,0,0,1,2.22,2.1,3.84,3.84,0,0,1,.32,1.55,3.78,3.78,0,0,1-.32,1.53,4,4,0,0,1-2.22,2.1,4.22,4.22,0,0,1-1.63.31,4.17,4.17,0,0,1-1.62-.31,4.07,4.07,0,0,1-1.33-.84,4,4,0,0,1-.89-1.26,3.78,3.78,0,0,1-.32-1.53,3.84,3.84,0,0,1,.32-1.55,4,4,0,0,1,.89-1.26,4.07,4.07,0,0,1,1.33-.84A4.17,4.17,0,0,1,114.71,147.58Zm0,1.8a2.27,2.27,0,0,0-1.61.63,2,2,0,0,0-.66,1.53,2.17,2.17,0,0,0,1.4,2,2.35,2.35,0,0,0,.87.16,2.28,2.28,0,0,0,.87-.16,2.07,2.07,0,0,0,.74-.47,2,2,0,0,0,.67-1.51,2,2,0,0,0-.67-1.53A2.32,2.32,0,0,0,114.71,149.38Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M123.58,147.58a4.14,4.14,0,0,1,1.62.31,4.07,4.07,0,0,1,1.33.84,4,4,0,0,1,.89,1.26,3.68,3.68,0,0,1,.32,1.55,3.62,3.62,0,0,1-.32,1.53,4,4,0,0,1-.89,1.26,4.07,4.07,0,0,1-1.33.84,4.14,4.14,0,0,1-1.62.31,4.22,4.22,0,0,1-1.63-.31,4.08,4.08,0,0,1-2.22-2.1,3.78,3.78,0,0,1-.32-1.53,3.84,3.84,0,0,1,.32-1.55,4.08,4.08,0,0,1,2.22-2.1A4.22,4.22,0,0,1,123.58,147.58Zm0,1.8A2.25,2.25,0,0,0,122,150a2,2,0,0,0-.67,1.53,2,2,0,0,0,.67,1.51,2,2,0,0,0,.73.47,2.37,2.37,0,0,0,.88.16,2.27,2.27,0,0,0,.86-.16,2.11,2.11,0,0,0,.75-.47,2,2,0,0,0,.66-1.51,2,2,0,0,0-.66-1.53A2.34,2.34,0,0,0,123.58,149.38Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M103.32,147.78v.59a4.43,4.43,0,0,0-1.06-.56,3.86,3.86,0,0,0-1.37-.23,4,4,0,0,0-1.6.31,3.8,3.8,0,0,0-1.27.84,3.87,3.87,0,0,0-.84,1.26,4,4,0,0,0-.3,1.55,3.94,3.94,0,0,0,.3,1.53,3.87,3.87,0,0,0,.84,1.26,3.8,3.8,0,0,0,1.27.84,4,4,0,0,0,1.6.31h.16a4.4,4.4,0,0,0,1.62-.3V153h0a2.16,2.16,0,0,1-.74.47,2.35,2.35,0,0,1-.87.16,2.22,2.22,0,0,1-.37,0h0a1.91,1.91,0,0,1-.51-.13,2,2,0,0,1-.73-.47,2,2,0,0,1-.66-1.51,2,2,0,0,1,.66-1.53,2.23,2.23,0,0,1,.73-.47,2.37,2.37,0,0,1,.88-.16,2.25,2.25,0,0,1,1.61.63,2,2,0,0,1,.66,1.53v3.94h1.9v-7.7Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.14,147.78h0v.58a4.43,4.43,0,0,0-1.06-.56,3.57,3.57,0,0,0-.68-.18,5.36,5.36,0,0,0-.82-.06,4,4,0,0,0-1.57.3,3.71,3.71,0,0,0-1.23.85A3.92,3.92,0,0,0,88,150a4.34,4.34,0,0,0-.28,1.54h0a3.94,3.94,0,0,0,.3,1.53,3.87,3.87,0,0,0,.84,1.26,3.71,3.71,0,0,0,1.27.84,4,4,0,0,0,1.6.31H92a4.29,4.29,0,0,0,1.49-.29V153h0a2.16,2.16,0,0,1-.74.47,2.35,2.35,0,0,1-.87.16,2.22,2.22,0,0,1-.37,0h0a1.91,1.91,0,0,1-.51-.13,2,2,0,0,1-.73-.47,2,2,0,0,1-.66-1.52,2.11,2.11,0,0,1,.15-.8l0-.06a2.14,2.14,0,0,1,.48-.66,2.23,2.23,0,0,1,.73-.47,2.37,2.37,0,0,1,.88-.16,2.25,2.25,0,0,1,1.61.63,2.14,2.14,0,0,1,.48.66l0,.06a2.16,2.16,0,0,1,.15.81v3a2,2,0,0,1-.66,1.51,2.33,2.33,0,0,1-2.75.34l-1.37,1.29a4.21,4.21,0,0,0,2.51.81,4.14,4.14,0,0,0,1.62-.31,4.29,4.29,0,0,0,1.33-.86,3.85,3.85,0,0,0,.89-1.26,3.54,3.54,0,0,0,.32-1.52v-6.75H94.14Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M64.76,162v.5h-2.2v-2.87h2.11v.51H63.12v.73h1.3v.48h-1.3V162Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68.39,159.4v3.06h-.57v-.13a1.25,1.25,0,0,1-.64.17,1.15,1.15,0,0,1,0-2.29,1.35,1.35,0,0,1,.64.17v-1Zm-.57,2.4v-.89a.84.84,0,0,0-.54-.19.64.64,0,0,0-.66.64.62.62,0,0,0,.66.63A.86.86,0,0,0,67.82,161.8Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M72,160.26v2.21h-.56v-.15a1,1,0,0,1-.6.18c-.65,0-1-.3-1-1v-1.22h.57v1.22c0,.35.16.51.48.51a.76.76,0,0,0,.5-.17v-1.56Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M75.48,162.06a1,1,0,0,1-.85.44,1.14,1.14,0,1,1,0-2.28,1.07,1.07,0,0,1,.86.44l-.36.34a.6.6,0,0,0-.5-.27.63.63,0,1,0,0,1.26.6.6,0,0,0,.5-.27Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M79.11,160.26v2.21h-.57v-.16a1.15,1.15,0,0,1-.64.19,1.15,1.15,0,0,1,0-2.29,1.26,1.26,0,0,1,.64.19v-.14Zm-.57.66a.81.81,0,0,0-.54-.19A.63.63,0,1,0,78,162a.85.85,0,0,0,.54-.18Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81.33,160.73v.78c0,.39.06.51.35.51l.26,0v.42a1.44,1.44,0,0,1-.52.08.63.63,0,0,1-.66-.69v-1.08h-.32v-.47h.32v-.86h.57v.86h.61v.47Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M83.3,159.72a.32.32,0,1,1,.64,0,.32.32,0,1,1-.64,0Zm0,.57h.57v2.21h-.57Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M87.75,161.36a1.21,1.21,0,1,1-1.2-1.14A1.17,1.17,0,0,1,87.75,161.36Zm-.55,0a.64.64,0,0,0-.65-.63.63.63,0,1,0,0,1.26A.64.64,0,0,0,87.2,161.36Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.28,161.27v1.23h-.57v-1.23c0-.34-.17-.51-.48-.51a.73.73,0,0,0-.49.17v1.57h-.56v-2.21h.56v.14a1.08,1.08,0,0,1,.59-.18C91,160.25,91.28,160.55,91.28,161.27Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.71,160.14v1h1.38v.5H95.71v.84h-.56v-2.87h2.16v.51Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M101,161.36a1.21,1.21,0,1,1-1.21-1.14A1.18,1.18,0,0,1,101,161.36Zm-.56,0a.63.63,0,0,0-.65-.63.63.63,0,1,0,0,1.26A.63.63,0,0,0,100.4,161.36Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.47,160.26v2.21h-.56v-.15a1,1,0,0,1-.61.18c-.64,0-.94-.3-.94-1v-1.22h.57v1.22c0,.35.16.51.48.51a.76.76,0,0,0,.5-.17v-1.56Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M108.1,161.27v1.23h-.56v-1.23c0-.34-.17-.51-.48-.51a.71.71,0,0,0-.49.17v1.57H106v-2.21h.57v.14a1,1,0,0,1,.59-.18C107.8,160.25,108.1,160.55,108.1,161.27Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.83,159.4v3.06h-.56v-.13a1.29,1.29,0,0,1-.65.17,1.15,1.15,0,0,1,0-2.29,1.4,1.4,0,0,1,.65.17v-1Zm-.56,2.4v-.89a.89.89,0,0,0-.55-.19.63.63,0,0,0-.65.64.62.62,0,0,0,.65.63A.89.89,0,0,0,111.27,161.8Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115.58,160.26v2.21H115v-.16a1.15,1.15,0,0,1-.64.19,1.15,1.15,0,0,1,0-2.29,1.29,1.29,0,0,1,.64.19v-.14Zm-.57.66a.83.83,0,0,0-.54-.19.63.63,0,1,0,0,1.26.88.88,0,0,0,.54-.18Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M117.79,160.73v.78c0,.39.07.51.35.51l.26,0v.42a1.3,1.3,0,0,1-.51.08.64.64,0,0,1-.67-.69v-1.08h-.31v-.47h.31v-.86h.57v.86h.62v.47Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.76,159.72a.33.33,0,0,1,.33-.33.32.32,0,0,1,.32.33.32.32,0,0,1-.32.33A.33.33,0,0,1,119.76,159.72Zm0,.57h.56v2.21h-.56Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124.22,161.36a1.21,1.21,0,1,1-1.21-1.14A1.18,1.18,0,0,1,124.22,161.36Zm-.56,0a.63.63,0,0,0-.65-.63.63.63,0,1,0,0,1.26A.63.63,0,0,0,123.66,161.36Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M127.74,161.27v1.23h-.56v-1.23c0-.34-.17-.51-.48-.51a.73.73,0,0,0-.49.17v1.57h-.56v-2.21h.56v.14a1.06,1.06,0,0,1,.59-.18C127.45,160.25,127.74,160.55,127.74,161.27Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M75.92,167.55v.5H73.71v-2.88h2.12v.51H74.27v.73h1.31v.49H74.27v.65Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.54,165v3.08H78v-.13a1.36,1.36,0,0,1-.65.17,1.15,1.15,0,0,1,0-2.3A1.36,1.36,0,0,1,78,166v-1ZM78,167.38v-.89a.88.88,0,0,0-.54-.19.64.64,0,0,0-.66.64.62.62,0,0,0,.66.63A.83.83,0,0,0,78,167.38Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81.15,165.84v2.21h-.57v-.15a1,1,0,0,1-.61.18c-.64,0-.94-.3-.94-1v-1.22h.56v1.22c0,.35.17.51.49.51a.76.76,0,0,0,.5-.17v-1.56Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M83.62,167.64a1.08,1.08,0,0,1-.86.44,1.15,1.15,0,1,1,0-2.29,1.08,1.08,0,0,1,.87.45l-.37.33a.61.61,0,0,0-.5-.27.65.65,0,0,0-.65.64.64.64,0,0,0,.65.63.58.58,0,0,0,.5-.27Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M86.24,165.84v2.21h-.57v-.16a1.21,1.21,0,0,1-.65.19,1.15,1.15,0,0,1,0-2.29,1.32,1.32,0,0,1,.65.18v-.13Zm-.57.66a.86.86,0,0,0-.55-.2.64.64,0,0,0-.66.64.63.63,0,0,0,.66.63.88.88,0,0,0,.55-.18Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M87.44,166.3v.79c0,.39.07.51.35.51l.26,0V168a1.3,1.3,0,0,1-.51.08.64.64,0,0,1-.67-.69V166.3h-.32v-.46h.32V165h.57v.87h.62v.46Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M88.4,165.26a.32.32,0,1,1,.64,0,.32.32,0,1,1-.64,0Zm0,.58H89v2.21h-.57Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.85,166.94a1.22,1.22,0,1,1-1.21-1.15A1.18,1.18,0,0,1,91.85,166.94Zm-.56,0a.65.65,0,0,0-.65-.64.66.66,0,0,0-.66.64.65.65,0,0,0,.66.63A.64.64,0,0,0,91.29,166.94Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.36,166.81v1.24H93.8v-1.24a.44.44,0,0,0-.49-.51.74.74,0,0,0-.49.18v1.57h-.56v-2.21h.56V166a1.09,1.09,0,0,1,.6-.18C94.07,165.79,94.36,166.1,94.36,166.81Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M98.64,166.77a4.37,4.37,0,0,1-.44.66l.35.34-.34.31-.32-.31a1.22,1.22,0,0,1-.76.31c-.66,0-1.09-.31-1.09-.83a.86.86,0,0,1,.61-.77.78.78,0,0,1-.26-.56.82.82,0,0,1,1.63-.06.9.9,0,0,1-.62.79l.49.47a2.89,2.89,0,0,0,.34-.48Zm-1,.68-.64-.63c-.23.1-.34.24-.34.41s.19.4.54.4A.65.65,0,0,0,97.59,167.45Zm-.72-1.51a.56.56,0,0,0,.25.41c.18-.06.43-.19.43-.42a.35.35,0,0,0-.35-.38A.36.36,0,0,0,96.87,165.94Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M102.44,165.17h.64l-1.34,2.88h-.27l-1.34-2.88h.63l.84,1.88Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M103.33,165.26a.33.33,0,0,1,.33-.33.32.32,0,0,1,.32.33.32.32,0,0,1-.32.33A.33.33,0,0,1,103.33,165.26Zm0,.58H104v2.21h-.57Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.57,167.45a1.72,1.72,0,0,0,.75.18c.27,0,.37-.1.37-.21s-.13-.18-.47-.26-.83-.26-.83-.69.33-.68.85-.68a2.33,2.33,0,0,1,.86.18l-.18.42a2.12,2.12,0,0,0-.69-.14c-.22,0-.33.08-.33.19s.14.18.49.26c.51.1.81.28.81.69s-.32.69-.89.69a2,2,0,0,1-1-.21Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M108.83,165.84v2.21h-.57v-.16a1.16,1.16,0,0,1-.65.19,1.15,1.15,0,0,1,0-2.29,1.32,1.32,0,0,1,.65.18v-.13Zm-.57.66a.86.86,0,0,0-.55-.2.63.63,0,0,0-.65.64.63.63,0,0,0,.65.63.88.88,0,0,0,.55-.18Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.87,167.21c0,.55-.45.88-1.12.88a2.2,2.2,0,0,1-1.19-.28l.21-.45a2,2,0,0,0,1,.22c.32,0,.51-.11.51-.32s-.2-.29-.62-.38c-.59-.14-1.06-.31-1.06-.87s.4-.87,1.06-.87a2.85,2.85,0,0,1,1.1.23l-.24.47a2.44,2.44,0,0,0-.88-.19c-.29,0-.45.13-.45.31s.2.29.63.39C112.44,166.48,112.87,166.68,112.87,167.21Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M113.75,167.1a.61.61,0,0,0,.63.5.69.69,0,0,0,.57-.28l.37.31a1.25,1.25,0,0,1-1,.45,1.15,1.15,0,0,1,0-2.29A1.07,1.07,0,0,1,115.4,167s0,.09,0,.12Zm0-.36h1.1a.48.48,0,0,0-.53-.49A.59.59,0,0,0,113.75,166.74Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.37,166.15a.85.85,0,0,1,.7-.36l.14,0v.62a1.42,1.42,0,0,0-.28,0,.53.53,0,0,0-.56.58v1.07h-.57v-2.21h.57Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.78,165.84l-1.06,2.21h-.27l-1.06-2.21H118l.61,1.25.6-1.25Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.07,165.26a.33.33,0,0,1,.33-.33.32.32,0,0,1,.32.33.32.32,0,0,1-.32.33A.33.33,0,0,1,120.07,165.26Zm.05.58h.57v2.21h-.57Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M123.18,167.64a1.08,1.08,0,0,1-.86.44,1.15,1.15,0,1,1,0-2.29,1.07,1.07,0,0,1,.86.45l-.36.33a.62.62,0,0,0-.5-.27.65.65,0,0,0-.65.64.64.64,0,0,0,.65.63.6.6,0,0,0,.5-.27Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124,167.1a.61.61,0,0,0,.63.5.71.71,0,0,0,.57-.28l.37.31a1.25,1.25,0,0,1-1,.45,1.15,1.15,0,0,1,0-2.29,1.06,1.06,0,0,1,1.07,1.19v.12Zm0-.36h1.1a.48.48,0,0,0-.53-.49A.59.59,0,0,0,124,166.74Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M126.11,167.45a1.73,1.73,0,0,0,.76.18c.26,0,.36-.1.36-.21s-.13-.18-.47-.26-.82-.26-.82-.69.33-.68.84-.68a2.39,2.39,0,0,1,.87.18l-.19.42a2.12,2.12,0,0,0-.69-.14c-.22,0-.33.08-.33.19s.14.18.49.26c.52.1.81.28.81.69s-.32.69-.89.69a1.9,1.9,0,0,1-.95-.21Z"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(191.53 186.83)"
  }, "Presentation Date")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(191.53 263.45)"
  }, "Presented by:")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 0.13,
    x2: 567.12,
    y2: 0.13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 319.02,
    x2: 567.12,
    y2: 319.02
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 0.13,
    x2: 0.19,
    y2: 319.02
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 319.09,
    y1: 0.13,
    x2: 319.09,
    y2: 319.02
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 32.08,
    y1: 0.13,
    x2: 32.08,
    y2: 319.02
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 63.97,
    y1: 0.13,
    x2: 63.97,
    y2: 319.02
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 95.86,
    y1: 0.13,
    x2: 95.86,
    y2: 319.02
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 127.75,
    y1: 0.13,
    x2: 127.75,
    y2: 319.02
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 159.64,
    y1: 0.13,
    x2: 159.64,
    y2: 319.02
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 191.53,
    y1: 0.13,
    x2: 191.53,
    y2: 319.02
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 223.42,
    y1: 0.13,
    x2: 223.42,
    y2: 319.02
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 255.31,
    y1: 0.13,
    x2: 255.31,
    y2: 319.02
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 287.2,
    y1: 0.13,
    x2: 287.2,
    y2: 319.02
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 16.13,
    y1: 0.13,
    x2: 16.13,
    y2: 319.02
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 48.02,
    y1: 0.13,
    x2: 48.02,
    y2: 319.02
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 79.91,
    y1: 0.13,
    x2: 79.91,
    y2: 319.02
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 111.8,
    y1: 0.13,
    x2: 111.8,
    y2: 319.02
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 143.69,
    y1: 0.13,
    x2: 143.69,
    y2: 319.02
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 175.58,
    y1: 0.13,
    x2: 175.58,
    y2: 319.02
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 207.47,
    y1: 0.13,
    x2: 207.47,
    y2: 319.02
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 239.36,
    y1: 0.13,
    x2: 239.36,
    y2: 319.02
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 271.25,
    y1: 0.13,
    x2: 271.25,
    y2: 319.02
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 303.14,
    y1: 0.13,
    x2: 303.14,
    y2: 319.02
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 287.13,
    x2: 567.12,
    y2: 287.13
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 255.24,
    x2: 567.12,
    y2: 255.24
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 223.35,
    x2: 567.12,
    y2: 223.35
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 191.46,
    x2: 567.12,
    y2: 191.46
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 159.57,
    x2: 567.12,
    y2: 159.57
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 127.68,
    x2: 567.12,
    y2: 127.68
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 95.79,
    x2: 567.12,
    y2: 95.79
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 63.9,
    x2: 567.12,
    y2: 63.9
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 32.01,
    x2: 567.12,
    y2: 32.01
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 303.08,
    x2: 567.12,
    y2: 303.08
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 271.19,
    x2: 567.12,
    y2: 271.19
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 239.3,
    x2: 567.12,
    y2: 239.3
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 207.41,
    x2: 567.12,
    y2: 207.41
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 175.52,
    x2: 567.12,
    y2: 175.52
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 143.63,
    x2: 567.12,
    y2: 143.63
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 111.74,
    x2: 567.12,
    y2: 111.74
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 79.85,
    x2: 567.12,
    y2: 79.85
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 47.96,
    x2: 567.12,
    y2: 47.96
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 0.19,
    y1: 16.07,
    x2: 567.12,
    y2: 16.07
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 350.98,
    y1: 0.13,
    x2: 350.98,
    y2: 319.02
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 382.87,
    y1: 0.13,
    x2: 382.87,
    y2: 319.02
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 414.76,
    y1: 0.13,
    x2: 414.76,
    y2: 319.02
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 446.65,
    y1: 0.13,
    x2: 446.65,
    y2: 319.02
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 478.54,
    y1: 0.2,
    x2: 478.54,
    y2: 319.09
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 335.03,
    y1: 0.13,
    x2: 335.03,
    y2: 319.02
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 366.92,
    y1: 0.13,
    x2: 366.92,
    y2: 319.02
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 398.81,
    y1: 0.13,
    x2: 398.81,
    y2: 319.02
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 430.7,
    y1: 0.13,
    x2: 430.7,
    y2: 319.02
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 462.59,
    y1: 0.13,
    x2: 462.59,
    y2: 319.02
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 510.42,
    y1: 0.13,
    x2: 510.42,
    y2: 319.02
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 542.31,
    y1: 0.13,
    x2: 542.31,
    y2: 319.02
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 494.48,
    y1: 0.13,
    x2: 494.48,
    y2: 319.02
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 526.37,
    y1: 0.13,
    x2: 526.37,
    y2: 319.02
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 558.26,
    y1: 0.13,
    x2: 558.26,
    y2: 319.02
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 0.19,
    y: 0.13,
    width: 566.93,
    height: 318.97
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMaterial8);
export default __webpack_public_path__ + "static/media/guideMaterial8.c40666062be1e6561958163ebdf6b8fd.svg";
export { ForwardRef as ReactComponent };